import React from 'react'
import { Link } from 'react-router-dom'
import SpinnerUI from '../output/SpinnerUI'
import ButtonTinyUI from './ButtonTinyUI'

// Tiny button with spinner to indicate busy
const ButtonTinyWithSpinnerUI = ({ label, className, onClick, busy, alignLeft, successMsg, errorList, rowId, disabled }) =>
  <span className={`g_flex_v ${className ? className : ''} ${alignLeft ? '' : 'g_text_right'}`}>
    {
      successMsg &&
      <span className='g_success'>{successMsg}</span>
    }
    {
      errorList && errorList.length > 0 &&
      <div className='g_error'>
        {errorList.map((error, index) => (
          <div key={index}>{error}</div>
        ))}
      </div>
    }
    <span className={`g_flex_h g_m_top_25 ${alignLeft ? 'g_flex_left' : 'g_flex_right'}`}>
      {
        !alignLeft &&
        <SpinnerUI className='g_m_right_50' reserveSpace={true} show={busy} />
      }
      <ButtonTinyUI label={label} onClick={onClick} rowId={rowId} disabled={disabled} />
      {
        alignLeft &&
        <SpinnerUI className='g_m_left_50' reserveSpace={true} show={busy} />
      }
    </span>
  </span>

export default ButtonTinyWithSpinnerUI
